import React from 'react';
import { Typography } from '@components/atoms/typography';
import type { LabeledFieldProps } from '@components/moleculs/labeled-field/types';
import cn from 'classnames';

import { FieldLabel } from '../../atoms/field-label';

import { LabeledFieldContainer } from './styles';

export const LabeledField: React.FC<LabeledFieldProps> = ({
    label,
    rightLabel,
    isRequired,
    children,
    className,
    labelClassName,
    style,
    fullWidth,
}) => (
    <LabeledFieldContainer className={cn(className, { 'full-width': fullWidth })} style={style}>
        <FieldLabel className={labelClassName}>
            <Typography variant='text' color='text-main'>
                {label} {isRequired ? ' *' : ''}
            </Typography>
            {!!rightLabel && <span>{rightLabel}</span>}
        </FieldLabel>
        {children}
    </LabeledFieldContainer>
);
